import _styled from "@emotion/styled-base";
import { css } from "@emotion/core";
import { Check } from "react-feather"; // eslint-disable-next-line @typescript-eslint/ban-types

var SegmentCheckIcon = /*#__PURE__*/_styled(Check, {
  target: "e162drai0"
})(function (_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/css("margin-right:", theme.space.xxs, ";");
});

export default SegmentCheckIcon;